import { render, staticRenderFns } from "./PersonalDetailsStep.component.vue?vue&type=template&id=a62ddb82&"
import script from "./PersonalDetailsStep.component.vue?vue&type=script&lang=ts&"
export * from "./PersonalDetailsStep.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports